import { type NoddiIconName } from 'noddi-ui-common';
import { NoddiCard } from 'noddi-ui-web';
import type { ReactNode } from 'react';
import { RiskIcon } from './RiskList';
import type { TireLeadSeverity } from './tireLeadReasonCopy';

export type StatusBandPoint = {
  icon: NoddiIconName;
  title: string;
  description: string;
  /** Overrides the band's severity, e.g. a neutral selling point after the risks. */
  severity?: TireLeadSeverity;
};

type Props = {
  /** The finding itself: the measurement, or what the technician found. */
  children: ReactNode;
  points: StatusBandPoint[];
  severity: TireLeadSeverity;
};

/** Desktop status (Claude Design "Tire Offer" desktop): the finding, then one column per consequence, in one card. */
export const StatusBand = ({ children, points, severity }: Props) => (
  <NoddiCard contentClassName='flex divide-x divide-border'>
    <div className='flex min-w-0 flex-[1.2] flex-col gap-4 pr-6'>{children}</div>
    {points.map((point) => (
      <div key={point.title} className='flex min-w-0 flex-1 flex-col gap-2.5 px-6 last:pr-0'>
        <RiskIcon icon={point.icon} severity={point.severity ?? severity} />
        <span className='font-semibold'>{point.title}</span>
        <span className='text-sm leading-relaxed text-muted-foreground'>{point.description}</span>
      </div>
    ))}
  </NoddiCard>
);
